import React from 'react';
import { useMenuState } from '../Common/MenuStateContext';
import { useAppTheme } from '../hooks/useAppTheme';
import { AppTopBarLead } from './AppTopBarLead';
import '../styles/shell.css';

interface DashboardShellProps {
  sidebar: React.ReactNode;
  children: React.ReactNode;
  containerClassName?: string;
  isMenuCollapsed?: boolean;
  /** When true, skip the overlay hamburger (ClientAppShell renders a full AppTopBar). */
  hideTopBarLead?: boolean;
}

const DashboardShell: React.FC<DashboardShellProps> = ({
  sidebar,
  children,
  containerClassName = '',
  isMenuCollapsed = false,
  hideTopBarLead = false,
}) => {
  useAppTheme();
  const { isMobileMenuOpen, closeMobileMenu } = useMenuState();

  // dash-main-container: restored page stylesheets scope their rules under it
  const shellClassName = [
    'app-shell',
    'dash-main-container',
    isMenuCollapsed ? 'app-shell--collapsed' : '',
    isMobileMenuOpen ? 'app-shell--mobile-open' : '',
    containerClassName,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={shellClassName}>
      {isMobileMenuOpen ? (
        <div className="app-shell__backdrop" onClick={closeMobileMenu} aria-hidden="true" />
      ) : null}

      <aside id="dashboard-sidebar-nav" className="app-shell__sidebar">
        {sidebar}
      </aside>

      <div className="app-shell__main">
        {!hideTopBarLead ? <AppTopBarLead /> : null}
        {children}
      </div>
    </div>
  );
};

export default DashboardShell;
